import { useCallback } from 'react';

import type { CustomOfferFormValues } from '@/typings/formValues';
import type { UseFormSetValue } from 'react-hook-form';

import { useGetParentFlightOrders } from '~/hooks/apis/orders/useGetParentFlightOrders';

type Params = {
  brand: string;
  customerId: string;
  enabled: boolean;
  isEditMode: boolean;
  setValue: UseFormSetValue<CustomOfferFormValues>;
};

export function useParentFlightOrderField({ brand, customerId, enabled, isEditMode, setValue }: Params) {
  const { data: parentOrders = [], isLoading, isError } = useGetParentFlightOrders(brand, customerId, enabled);

  // Create only: an edited offer keeps its link after the parent has flown.
  const isUnavailable = enabled && !isEditMode && !isLoading && !isError && parentOrders.length === 0;

  const selectParentOrder = useCallback(
    (orderId: string) => {
      const parent = parentOrders.find((candidate) => candidate.order.id_orders === orderId);
      if (!parent) {
        return;
      }
      setValue('parent_order_id', orderId, { shouldValidate: true, shouldDirty: true });
      setValue('created_from_item_id', parent.parentItemId);
    },
    [parentOrders, setValue],
  );

  return { parentOrders, isLoading, isError, isUnavailable, selectParentOrder };
}
